import { colors } from '../../colors';
var para = {
  messageColor: colors.nvaBlack
};
export default para;